import { render } from "./Category.vue?vue&type=template&id=3229448b&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "@/assets/scss/_filter_TEMP.scss?vue&type=style&index=0&id=3229448b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3229448b"]])

export default __exports__